import * as THREE from 'three';

export const FISH_MODEL_IDS = Object.freeze(['clownfish', 'butterflyfish', 'tang', 'parrotfish', 'silverJack']);

// Lengths include tails; body dimensions deliberately differ in all three axes.
// +X is the head, +Y is up. Colors are converted from sRGB to linear by THREE.Color.
export const FISH_MODELS = Object.freeze({
  clownfish: Object.freeze({ id: 'clownfish', label: '小丑鱼', headShape: 'round snout', bodyShape: 'short deep oval', tailShape: 'rounded fan', finStyle: 'arched continuous dorsal',
    dimensions: { length: 1.271, height: .632, width: .548 }, bodyDimensions: { length: .80, height: .46, width: .31 },
    palette: { body: '#f57821', belly: '#ffb151', light: '#fff4d1', dark: '#242b32', fin: '#ee9b37' },
    tailStart: -.34, tailAmplitude: .060, tailFrequency: 5.7 }),
  butterflyfish: Object.freeze({ id: 'butterflyfish', label: '蝴蝶鱼', headShape: 'projecting tapered snout', bodyShape: 'thin tall disc', tailShape: 'round paddle', finStyle: 'high swept dorsal',
    dimensions: { length: 1.197, height: .899, width: .324 }, bodyDimensions: { length: .58, height: .71, width: .14 },
    palette: { body: '#f7ce46', belly: '#fff0a2', light: '#fff6d2', dark: '#26374a', fin: '#f1b833' },
    tailStart: -.26, tailAmplitude: .043, tailFrequency: 5.1 }),
  tang: Object.freeze({ id: 'tang', label: '蓝吊鱼', headShape: 'pointed snout', bodyShape: 'compressed oval', tailShape: 'crescent', finStyle: 'dorsal and anal sails',
    dimensions: { length: 1.233, height: .763, width: .422 }, bodyDimensions: { length: .77, height: .51, width: .20 },
    palette: { body: '#216ee2', belly: '#52b8ec', light: '#dbeffd', dark: '#192e64', fin: '#2e83df', tail: '#f8d344' },
    tailStart: -.35, tailAmplitude: .065, tailFrequency: 5.3 }),
  parrotfish: Object.freeze({ id: 'parrotfish', label: '鹦嘴鱼', headShape: 'blunt ivory beak', bodyShape: 'thick elongated oval', tailShape: 'broad shallow notch', finStyle: 'low continuous dorsal',
    dimensions: { length: 1.470, height: .557, width: .644 }, bodyDimensions: { length: .97, height: .46, width: .36 },
    palette: { body: '#28a899', belly: '#66d6c8', light: '#ffe5af', dark: '#204a55', fin: '#35c8bc', accent: '#ed8c9c' },
    tailStart: -.45, tailAmplitude: .047, tailFrequency: 4.2 }),
  silverJack: Object.freeze({ id: 'silverJack', label: '银鲹', headShape: 'athletic tapered wedge', bodyShape: 'long streamlined fusiform', tailShape: 'deep fork', finStyle: 'two separate dorsal fins and swept pectorals',
    dimensions: { length: 1.482, height: .699, width: .766 }, bodyDimensions: { length: 1.10, height: .36, width: .27 },
    palette: { body: '#b8d5df', belly: '#eef4eb', light: '#f8ebbf', dark: '#36556c', fin: '#688fa6', back: '#668eaa' },
    tailStart: -.51, tailAmplitude: .082, tailFrequency: 6.2 }),
});

const PROFILES = {
  clownfish: [
    [-0.37,-0.025,0.052,0.042],
    [-0.3,-0.015,0.139,0.086],
    [-0.285,-0.0105,0.1507,0.095],
    [-0.275,-0.0075,0.1585,0.101],
    [-0.268,-0.0054,0.16396,0.1052],
    [-0.26,-0.003,0.1702,0.11],
    [-0.235,0.005143,0.184429,0.122],
    [-0.228,0.007543,0.187429,0.1248],
    [-0.22,0.010286,0.190857,0.128],
    [-0.213,0.012267,0.1938,0.1306],
    [-0.1,0.0068,0.2204,0.1533],
    [-0.077,0.00492,0.2228,0.15436],
    [-0.069,0.00444,0.2236,0.15452],
    [-0.063,0.00408,0.2242,0.15464],
    [-0.056,0.00366,0.2249,0.15478],
    [0,0.0057,0.2242,0.1514],
    [0.007,0.006171,0.2236,0.150714],
    [0.014,0.006771,0.2222,0.149714],
    [0.021,0.007371,0.2208,0.148714],
    [0.175,0.019286,0.171286,0.113],
    [0.184,0.020057,0.166657,0.1112],
    [0.191,0.020657,0.163057,0.1098],
    [0.198,0.0214,0.1591,0.108],
    [0.237,0.023691,0.139382,0.095945],
    [0.244,0.022927,0.137855,0.094164],
    [0.251,0.022164,0.136327,0.092382],
    [0.258,0.0214,0.1348,0.0906],
    [0.32,0.007,0.117333,0.074333],
    [0.4,-0.018,0.079,0.051],
    [0.43,-0.025,0.05,0.039],
  ],
  butterflyfish: [
    [-.27, -.025, .040, .025], [-.21, -.002, .174, .042], [-.15, .008, .272, .061], [-.07, .016, .344, .069],
    [.025, .006, .352, .071], [.11, -.003, .302, .065], [.19, -.002, .224, .052],
    [.245, -.008, .146, .042], [.30, -.031, .085, .031], [.355, -.039, .046, .023],
  ],
  tang: [
    [-.36, -.016, .035, .031], [-.29, .006, .124, .059], [-.20, .014, .214, .086], [-.09, .014, .249, .098],
    [.045, .008, .257, .102], [.16, -.005, .210, .088], [.25, -.014, .153, .071],
    [.315, -.025, .108, .053], [.37, -.032, .065, .035], [.41, -.032, .029, .022],
  ],
  parrotfish: [
    [-.45, -.010, .034, .039], [-.37, .001, .119, .088], [-.26, .013, .173, .132], [-.12, .006, .208, .162],
    [.04, -.008, .227, .180], [.19, -.009, .218, .173], [.32, -.005, .194, .151],
    [.40, -.015, .161, .130], [.47, -.028, .124, .109], [.51, -.044, .100, .090],
  ],
  silverJack: [
    [-.53, -.016, .027, .027], [-.44, -.013, .052, .042], [-.33, -.007, .099, .072], [-.17, .004, .152, .112],
    [.01, .005, .179, .137], [.18, -.005, .168, .126], [.31, -.014, .129, .101],
    [.43, -.028, .081, .071], [.51, -.035, .043, .043], [.56, -.037, .020, .023],
  ],
};

// The profile defines an actual changing cross-section, rather than scaling a
// shared source fish. Unequal belly/back exponents keep the head and belly broad.
const crossSection = (id, angle) => {
  const s = Math.sin(angle), c = Math.cos(angle);
  const breadth = id === 'parrotfish' ? .83 : id === 'butterflyfish' ? 1.08 : .96;
  const vertical = Math.sign(s) * Math.pow(Math.abs(s), s < 0 ? .91 : 1.05);
  return [vertical, Math.sign(c) * Math.pow(Math.abs(c), breadth)];
};
const color = value => new THREE.Color(value);

class FishBuilder {
  constructor(id) { this.id = id; this.positions = []; this.colors = []; this.indices = []; this.parts = []; this.landmarks = {}; }
  start(id, kind, description) { return { id, kind, description, vertexStart: this.positions.length / 3, indexStart: this.indices.length }; }
  finish(part) { part.vertexCount = this.positions.length / 3 - part.vertexStart; part.indexCount = this.indices.length - part.indexStart; this.parts.push(part); }
  vertex(x, y, z, tint) { const index = this.positions.length / 3; this.positions.push(x, y, z); this.colors.push(tint.r, tint.g, tint.b); return index; }
  triangle(a, b, c) { this.indices.push(a, b, c); }
  face(points, tint) { const v = points.map(p => this.vertex(...p, tint)); for (let i = 1; i < v.length - 1; i++) this.triangle(v[0], v[i], v[i + 1]); }
  body(profile, palette) {
    const part = this.start('body', 'body', FISH_MODELS[this.id].bodyShape), sides = 12;
    const body = color(palette.body), belly = color(palette.belly), dark = color(palette.dark), light = color(palette.light);
    const ringColors = (x, angle) => {
      const side = Math.cos(angle), height = Math.sin(angle), tint = body.clone().lerp(belly, Math.max(0, -height) * .58);
      if (this.id === 'clownfish') {
        // Three narrow cream saddles. Closely spaced colored rings keep each
        // dark edge narrow and leave broad clean orange intervals between them.
        if ((x >= -.260 && x <= -.235) || (x >= -.056 && x <= 0) || (x >= .198 && x <= .237)) tint.copy(light);
        else if ((x >= -.275 && x <= -.268) || (x >= -.228 && x <= -.220) || (x >= -.069 && x <= -.063) || (x >= .007 && x <= .014) || (x >= .184 && x <= .191) || (x >= .244 && x <= .251)) tint.copy(dark);
      } else if (this.id === 'butterflyfish') {
        if (x >= .19 && x <= .30) tint.lerp(dark, .96);
        else if (x > -.07 && x < .11 && Math.abs(side) > .4) tint.lerp(light, .70);
      } else if (this.id === 'tang') {
        if (x < .25 && x > -.29 && height > -.12 && Math.abs(side) > .42) tint.lerp(dark, .73);
      } else if (this.id === 'parrotfish') {
        if (x > .32 && height > -.10) tint.lerp(color(palette.accent), .66);
        else if (Math.abs(side) > .4 && height < .32 && height > -.45) tint.lerp(belly, .46);
      } else if (this.id === 'silverJack') {
        tint.lerp(color(palette.back), Math.max(0, height) * .85);
        if (height < .0 && height > -.55) tint.lerp(light, .18);
      }
      return tint;
    };
    profile.forEach(([x, cy, ry, rz]) => {
      for (let j = 0; j < sides; j++) { const angle = j / sides * Math.PI * 2, [v, w] = crossSection(this.id, angle); this.vertex(x, cy + v * ry, w * rz, ringColors(x, angle)); }
    });
    const offset = part.vertexStart;
    for (let i = 0; i < profile.length - 1; i++) for (let j = 0; j < sides; j++) {
      const a = offset + i * sides + j, b = offset + i * sides + (j + 1) % sides, c = offset + (i + 1) * sides + j, d = offset + (i + 1) * sides + (j + 1) % sides;
      this.triangle(a, c, b); this.triangle(b, c, d);
    }
    // Both end rings retain area. A separate point seals them, avoiding zero-radius rings.
    const first = profile[0], last = profile.at(-1);
    const rear = this.vertex(first[0] - .025, first[1], 0, body), front = this.vertex(last[0] + .016, last[1], 0, ringColors(last[0], 0));
    for (let j = 0; j < sides; j++) { this.triangle(rear, offset + j, offset + (j + 1) % sides); this.triangle(front, offset + (profile.length - 1) * sides + (j + 1) % sides, offset + (profile.length - 1) * sides + j); }
    this.finish(part); this.landmarks.bodyProfile = profile.map(row => [...row]);
  }
  // Closed flat-sided fins have a real edge thickness; neither side is transparent.
  fin(id, polygon, thickness, tint, edgeTint, { plane = 'xy', offset = 0, kind = 'fin' } = {}) {
    const part = this.start(id, kind, id.replaceAll('-', ' ')), flat = color(tint), edge = color(edgeTint);
    let contour = polygon.map(([x, y]) => new THREE.Vector2(x, y));
    if (!THREE.ShapeUtils.isClockWise(contour)) contour.reverse();
    const points = contour.map(p => [p.x, p.y]);
    const rootA = polygon[0], rootB = polygon.at(-1), rootDx = rootB[0] - rootA[0], rootDy = rootB[1] - rootA[1];
    const rootLengthSq = rootDx * rootDx + rootDy * rootDy;
    const rootDistance = p => {
      const t = Math.max(0, Math.min(1, ((p[0] - rootA[0]) * rootDx + (p[1] - rootA[1]) * rootDy) / rootLengthSq));
      return Math.hypot(p[0] - rootA[0] - rootDx * t, p[1] - rootA[1] - rootDy * t);
    };
    const reach = Math.max(...points.map(rootDistance));
    const localThickness = p => thickness * (.25 + .75 * (1 - rootDistance(p) / reach));
    const map = (p, side) => plane === 'xy' ? [p[0], p[1], offset + side * localThickness(p) / 2] : [p[0], offset + side * localThickness(p) / 2, p[1]];
    const triangles = THREE.ShapeUtils.triangulateShape(contour, []);
    // Explicit face orientation is selected geometrically; this works for both planes.
    const upper = plane === 'xy' ? new THREE.Vector3(0, 0, 1) : new THREE.Vector3(0, 1, 0);
    const emit = (verts, desired, faceColor) => {
      const a = new THREE.Vector3(...verts[0]), b = new THREE.Vector3(...verts[1]), c = new THREE.Vector3(...verts[2]);
      if (b.clone().sub(a).cross(c.clone().sub(a)).dot(desired) < 0) verts.reverse();
      this.face(verts, faceColor);
    };
    for (const indices of triangles) {
      emit(indices.map(i => map(points[i], 1)), upper, flat);
      emit(indices.map(i => map(points[i], -1)), upper.clone().negate(), flat);
    }
    for (let i = 0; i < points.length; i++) {
      const a = points[i], b = points[(i + 1) % points.length];
      const outward = plane === 'xy' ? new THREE.Vector3(-(b[1] - a[1]), b[0] - a[0], 0) : new THREE.Vector3(-(b[1] - a[1]), 0, b[0] - a[0]);
      emit([map(a, -1), map(b, -1), map(b, 1), map(a, 1)], outward, edge);
    }
    this.finish(part); this.landmarks[id] = { polygon: points, thickness, tipThickness: thickness * .25, tapered: true, plane, offset };
  }
  ellipsoid(id, center, radii, tint, kind = 'detail', sides = 8, rings = 4) {
    const part = this.start(id, kind, id.replaceAll('-', ' ')), c = color(tint), [cx, cy, cz] = center, [rx, ry, rz] = radii;
    const top = this.vertex(cx, cy + ry, cz, c);
    for (let j = 1; j < rings; j++) for (let i = 0; i < sides; i++) {
      const phi = Math.PI * j / rings, theta = Math.PI * 2 * i / sides;
      this.vertex(cx + rx * Math.sin(phi) * Math.cos(theta), cy + ry * Math.cos(phi), cz + rz * Math.sin(phi) * Math.sin(theta), c);
    }
    const bottom = this.vertex(cx, cy - ry, cz, c), first = top + 1;
    for (let i = 0; i < sides; i++) {
      this.triangle(top, first + (i + 1) % sides, first + i);
      for (let j = 0; j < rings - 2; j++) { const a = first + j * sides + i, b = first + j * sides + (i + 1) % sides, d = first + (j + 1) * sides + i, e = first + (j + 1) * sides + (i + 1) % sides; this.triangle(a, b, d); this.triangle(b, e, d); }
      const end = first + (rings - 2) * sides; this.triangle(bottom, end + i, end + (i + 1) % sides);
    }
    this.finish(part); this.landmarks[id] = { center, radii };
  }
  eyes(x, y, z, radius, palette) {
    for (const side of [-1, 1]) {
      const suffix = side < 0 ? 'right' : 'left';
      this.ellipsoid(`eye-iris-${suffix}`, [x, y, side * z], [radius, radius * 1.07, .018], palette.light, 'eye');
      this.ellipsoid(`eye-pupil-${suffix}`, [x + radius * .12, y, side * (z + .015)], [radius * .56, radius * .68, .009], '#152431', 'eye', 8, 3);
    }
  }
  build() {
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(this.positions, 3));
    geometry.setAttribute('color', new THREE.Float32BufferAttribute(this.colors, 3));
    geometry.setIndex(this.indices); geometry.computeVertexNormals(); geometry.computeBoundingBox(); geometry.computeBoundingSphere();
    geometry.userData = { fishModelId: this.id, parts: this.parts, landmarks: this.landmarks, coordinateSystem: '+X forward, +Y up, +Z left', opaqueVertexColors: true };
    return geometry;
  }
}

export function createFishGeometry(id) {
  const model = Object.hasOwn(FISH_MODELS, id) && FISH_MODELS[id];
  if (!model) throw new RangeError(`Unknown fish model: ${id}`);
  const b = new FishBuilder(id), p = model.palette;
  b.body(PROFILES[id], p);
  if (id === 'clownfish') {
    b.fin('dorsal-arched', [[-.33,.08],[-.26,.245],[-.16,.317],[.02,.342],[.19,.276],[.285,.135],[.18,.174],[-.06,.221]], .032, p.fin, p.dark);
    b.fin('anal-round', [[-.32,-.06],[-.255,-.205],[-.13,-.29],[.015,-.268],[.07,-.15],[-.11,-.185]], .030, p.fin, p.dark);
    b.fin('tail-rounded', [[-.34,-.058],[-.55,-.142],[-.675,-.203],[-.724,-.186],[-.763,-.143],[-.787,-.077],[-.795,-.001],[-.785,.079],[-.761,.145],[-.721,.190],[-.671,.206],[-.53,.142],[-.34,.040]], .044, p.fin, p.dark, {kind:'tail'});
    for (const side of [-1,1]) b.fin(`pectoral-${side}`, [[.13,side*.103],[-.005,side*.246],[-.15,side*.274],[-.13,side*.128]], .029, p.fin, p.dark, {plane:'xz',offset:-.045});
    b.ellipsoid('mouth-round', [.459,-.039,0], [.020,.025,.039], p.dark, 'mouth', 8, 3);
    b.eyes(.312,.083,.082,.030,p);
  } else if (id === 'butterflyfish') {
    b.fin('dorsal-swept', [[-.245,.064],[-.275,.185],[-.259,.303],[-.226,.392],[-.169,.448],[-.096,.475],[-.015,.462],[.060,.412],[.128,.325],[.194,.214],[.220,.133],[.12,.214],[.026,.299],[-.10,.292],[-.18,.190]], .023, p.fin, p.dark);
    for (const side of [-1,1]) b.ellipsoid(`dorsal-eye-spot-${side}`, [-.157,.328,side*.018], [.039,.047,.011], p.dark, 'pattern', 8, 3);
    b.fin('anal-swept', [[-.25,-.033],[-.266,-.175],[-.255,-.284],[-.214,-.366],[-.153,-.411],[-.076,-.424],[.00,-.391],[.082,-.319],[.151,-.225],[.18,-.162],[.09,-.213],[-.02,-.240],[-.16,-.179]], .023, p.fin, p.dark);
    b.fin('tail-paddle', [[-.255,-.035],[-.442,-.12],[-.557,-.180],[-.600,-.166],[-.639,-.130],[-.661,-.066],[-.668,0],[-.657,.067],[-.632,.127],[-.596,.164],[-.548,.175],[-.431,.115],[-.255,.025]], .030, p.belly, p.fin, {kind:'tail'});
    // Long tube-like snout is separate from the tall disc and ends in a little mouth.
    b.ellipsoid('snout-projecting', [.404,-.050,0], [.111,.040,.026], p.belly, 'snout', 8, 4);
    b.ellipsoid('mouth-tip', [.519,-.054,0], [.010,.018,.021], p.dark, 'mouth', 8, 3);
    for (const side of [-1,1]) b.fin(`pectoral-${side}`, [[.135,side*.046],[-.008,side*.162],[-.124,side*.152],[-.065,side*.043]], .020, p.belly, p.fin, {plane:'xz',offset:-.038});
    b.eyes(.238,.083,.040,.029,p);
  } else if (id === 'tang') {
    b.fin('dorsal-sail', [[-.34,.038],[-.326,.151],[-.280,.251],[-.216,.320],[-.130,.372],[-.036,.397],[.054,.391],[.128,.354],[.198,.286],[.254,.184],[.270,.126],[.13,.201],[-.02,.247],[-.16,.205]], .027, p.fin, p.dark);
    b.fin('anal-sail', [[-.342,-.044],[-.327,-.142],[-.284,-.240],[-.218,-.314],[-.131,-.360],[-.041,-.366],[.044,-.333],[.122,-.270],[.188,-.171],[.101,-.179],[-.03,-.237],[-.15,-.184]], .027, p.fin, p.dark);
    b.fin('tail-crescent', [[-.34,-.040],[-.486,-.103],[-.685,-.300],[-.793,-.290],[-.746,-.172],[-.587,-.022],[-.587,.002],[-.752,.173],[-.790,.301],[-.665,.295],[-.476,.082],[-.34,.024]], .037, p.tail, p.dark, {kind:'tail'});
    for (const side of [-1,1]) b.fin(`pectoral-${side}`, [[.128,side*.080],[-.018,side*.211],[-.198,side*.190],[-.088,side*.072]], .025, p.tail, p.fin, {plane:'xz',offset:-.043});
    b.ellipsoid('mouth-point', [.428,-.035,0], [.014,.019,.024], p.dark, 'mouth', 8, 3);
    b.eyes(.264,.064,.063,.025,p);
  } else if (id === 'parrotfish') {
    b.fin('dorsal-low', [[-.416,.051],[-.323,.183],[-.177,.241],[.028,.292],[.209,.263],[.347,.179],[.267,.161],[.012,.184],[-.247,.136]], .037, p.fin, p.accent);
    b.fin('anal-low', [[-.406,-.04],[-.319,-.162],[-.173,-.257],[.029,-.265],[.103,-.180],[-.174,-.179]], .036, p.fin, p.accent);
    b.fin('tail-notched', [[-.426,-.045],[-.606,-.124],[-.854,-.201],[-.844,-.078],[-.784,-.004],[-.843,.074],[-.854,.199],[-.603,.118],[-.426,.027]], .055, p.fin, p.accent, {kind:'tail'});
    for (const side of [-1,1]) {
      b.fin(`pectoral-${side}`, [[.238,side*.124],[.058,side*.277],[-.093,side*.322],[-.054,side*.149]], .033, p.fin, p.accent, {plane:'xz',offset:-.054});
      b.fin(`pelvic-${side}`, [[.08,side*.083],[-.036,side*.160],[-.148,side*.139],[-.039,side*.063]], .023, p.accent, p.dark, {plane:'xz',offset:-.19});
    }
    // The upper and lower ivory plates protrude beyond the blunt forehead.
    b.ellipsoid('beak-upper', [.553,-.032,0], [.063,.052,.087], p.light, 'beak', 10, 4);
    b.ellipsoid('beak-lower', [.551,-.089,0], [.052,.033,.075], '#f1d999', 'beak', 10, 4);
    b.ellipsoid('mouth-beak-seam', [.604,-.065,0], [.009,.008,.067], p.dark, 'mouth', 8, 3);
    b.eyes(.397,.076,.109,.031,p);
  } else {
    b.fin('dorsal-anterior', [[.014,.142],[-.047,.379],[-.147,.275],[-.218,.11]], .025, p.fin, p.dark);
    b.fin('dorsal-posterior', [[-.185,.104],[-.280,.201],[-.407,.106],[-.459,.029],[-.334,.054]], .024, p.fin, p.dark);
    b.fin('anal-swept', [[-.21,-.109],[-.270,-.320],[-.361,-.173],[-.457,-.046],[-.327,-.059]], .024, p.fin, p.dark);
    b.fin('tail-forked', [[-.51,-.037],[-.627,-.105],[-.819,-.291],[-.880,-.273],[-.807,-.128],[-.670,-.023],[-.670,-.009],[-.812,.135],[-.880,.307],[-.806,.294],[-.613,.074],[-.51,.014]], .035, p.fin, p.dark, {kind:'tail'});
    // Long swept pectorals are visible from the elevated game camera, not just in profile.
    for (const side of [-1,1]) b.fin(`pectoral-long-${side}`, [[.201,side*.107],[-.068,side*.354],[-.372,side*.383],[-.246,side*.176],[.076,side*.091]], .025, p.fin, p.dark, {plane:'xz',offset:-.048});
    b.ellipsoid('mouth-wedge-tip', [.586,-.042,0], [.018,.014,.024], p.dark, 'mouth', 8, 3);
    b.eyes(.380,.039,.081,.023,p);
  }
  return b.build();
}
